import React from 'react';

const Healthz: React.FC = () => {
  return <div>OK</div>;
};

export default Healthz;
